import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Route guards
import { UserRouteGuard } from './user/service/user.routeguard';

import { JsonFormContComponent } from './json-form/compc/json-form-cont/json-form-cont.component';
import { SignInViewComponent } from './user/compv/signin-view/signin-view.component';
import { MaengelContComponent } from './maengel/compc/maengel-cont/maengel-cont.component';
import { NavContComponent } from './nav/compc/nav-cont/nav-cont.component';
import { ChangePasswordCardComponent } from './user/compv/change-password-card/change-password-card.component';

const routes: Routes = [
    {
        path: 'navigation',
        component: NavContComponent,
        canActivate: [UserRouteGuard]
    },
    {
        path: 'signin',
        component: SignInViewComponent
    },
    {
        path: 'jss',
        component: JsonFormContComponent            // for development purpose
    },
    {
        path: 'password',
        component: ChangePasswordCardComponent,
        canActivate: [UserRouteGuard]
    },
    // default routes - should always be there
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/navigation'
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/navigation'
    }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/app-routing.module.ts